export default __webpack_public_path__ + "static/0069-1f5d1fb4ef96984714bd8a3748aafca0.png";